import * as Yup from "yup";
import Modal from "components/DesignSystem/Modal/Modal";
import { Button } from "components/DesignSystem/Button/Button";
import { PriceInput } from "components/PriceInput/PriceInput";
import {
  Combobox,
  OptionData,
} from "components/DesignSystem/Combobox/Combobox";
import { FormikForm } from "components/FormikForm/FormikForm";
import { YEAR_OPTIONS } from "../constants";

export type S174Form = {
  period_year: string;
  amount: string;
};

export const S174_FORM_VALIDATION_SCHEMA = Yup.object({
  period_year: Yup.string().required("Tax year is required"),
  amount: Yup.number()
    .typeError("Enter a valid amount")
    .positive("Amount must be greater than 0")
    .required("Amount is required"),
});

type Props = {
  open: boolean;
  onClose: () => void;
  initialValues: S174Form;
  title: string;
  submitLabel: string;
  isLoading: boolean;
  onSubmit: (values: S174Form) => Promise<void>;
};

export const S174EntryFormModal = ({
  open,
  onClose,
  initialValues,
  title,
  submitLabel,
  isLoading,
  onSubmit,
}: Props) => {
  return (
    <Modal.Root open={open} onOpenChange={(o) => !o && onClose()}>
      <Modal.Content useCustomOverlay>
        <FormikForm<S174Form>
          initialValues={initialValues}
          validationSchema={S174_FORM_VALIDATION_SCHEMA}
          onSubmit={onSubmit}
        >
          {({ values, setFieldValue }) => (
            <>
              <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
                <Modal.Close onClick={onClose} />
              </Modal.Header>
              <Modal.Body className="t-space-y-4">
                <div className="t-grid t-grid-cols-2 t-gap-4">
                  <Combobox
                    name="period_year"
                    label="Tax year"
                    required
                    options={YEAR_OPTIONS}
                    placeholder="Select year"
                    menuPortalTarget={document.body}
                    value={
                      YEAR_OPTIONS.find(
                        (o) => o.value === values.period_year
                      ) ?? null
                    }
                    onChange={(option) => {
                      const opt = option as OptionData | null;
                      setFieldValue("period_year", opt?.value ?? "");
                    }}
                  />
                  <PriceInput
                    name="amount"
                    label="Amount"
                    required
                    allowNegative={false}
                    placeholder="Enter amount"
                  />
                </div>
              </Modal.Body>
              <Modal.FooterButtonGroup>
                <Modal.RawClose asChild>
                  <Button disabled={isLoading}>Cancel</Button>
                </Modal.RawClose>
                <Button
                  type="submit"
                  customType="primary"
                  isLoading={isLoading}
                  disabled={isLoading}
                >
                  {submitLabel}
                </Button>
              </Modal.FooterButtonGroup>
            </>
          )}
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
